import Vue from 'vue'
import Vuex from 'vuex'
import fewdss from './modules/fewdss'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: { fewdss },
})
